/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summaryreturningtile2Inputs */

const en_summaryreturningtile2 = /** @type {(inputs: Summaryreturningtile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Came back`)
};

const de_summaryreturningtile2 = /** @type {(inputs: Summaryreturningtile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiedergekommen`)
};

/**
* | output |
* | --- |
* | "Came back" |
*
* @param {Summaryreturningtile2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summaryreturningtile2 = /** @type {((inputs?: Summaryreturningtile2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summaryreturningtile2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summaryreturningtile2(inputs)
	return de_summaryreturningtile2(inputs)
});
export { summaryreturningtile2 as "summaryReturningTile" }